import React, {useState} from 'react';
import { motion } from 'framer-motion';
import '../css/Home.css';
import industries01 from '../../images/industries1.gif';
import industries02 from '../../images/industries2.gif';
import industries03 from '../../images/industries3.gif';
import industries04 from '../../images/industries4.gif';
import industries05 from '../../images/industries5.gif';
import industries06 from '../../images/industries6.gif';
import industries07 from '../../images/industries7.gif';

function Industries() {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        "Fintech & Insurtech", "Media & Communications", "Healthcare", "Retail & E-Commerce", "Entertainment & Gaming", "Logistics", "Real Estate & Construction", 
    ];
    const tabContents = [
        {
            title: "Innovate and secure your global financial operations with Peregrinee’s specialized offshore software solutions for Fintech and Insurtech industries.",
            text: "Peregrinee specializes in offshore software solutions for the Fintech and Insurtech industries, enabling financial institutions and insurance providers to digitally innovate securely and rapidly. Our offshore teams develop customized financial technology applications, secure digital wallets, blockchain-based solutions, automated claim processing systems, and advanced risk management tools. This enables our clients to deliver seamless digital financial services that comply with international regulatory standards.",
            img: industries01
        },
        {
            title: "Engage global audiences with Peregrinee’s immersive and interactive offshore entertainment and gaming solutions designed to captivate and retain users.",
            text: "Our offshore software development services for the Media & Communications industry are designed to enhance content delivery, streamline communication processes, and increase audience engagement. Peregrinee provides innovative digital solutions such as content management systems, media analytics platforms, and integrated digital marketing tools, empowering media organizations to effectively manage content across diverse digital channels and deliver targeted communication that resonates globally.",
            img: industries02
        },
        {
            title: "Accelerate digital innovation in healthcare with Peregrinee’s secure and scalable offshore software solutions built to enhance patient care, operational efficiency, and regulatory compliance.",
            text: "Peregrinee’s offshore development expertise empowers healthcare organizations to modernize their digital infrastructure, streamline clinical workflows, and deliver patient-centric care. From secure telehealth platforms and electronic health records (EHR) to AI-driven diagnostics and hospital management systems, we build compliant, data-driven solutions that support better outcomes, reduce operational friction, and ensure full alignment with global health standards and privacy regulations.",
            img: industries03
        },
        {
            title: "Expand your global retail and e-commerce presence with Peregrinee’s tailored offshore software solutions designed to optimize customer experiences and operational efficiency.",
            text: "Peregrinee helps global retail and e-commerce businesses expand their digital presence and enhance customer experiences through robust offshore software development. Our specialized solutions include scalable e-commerce platforms, sophisticated inventory management systems, customer relationship management (CRM) tools, and personalized digital marketing automation systems. These tools enable businesses to effectively engage customers, increase conversions, and optimize global supply chain operations.",
            img: industries04
        },
        {
            title: "Deliver unforgettable digital experiences with Peregrinee’s offshore development solutions for immersive gaming, interactive media, and user engagement at scale.",
            text: "Peregrinee brings deep technical expertise and creative innovation to the entertainment and gaming industry, delivering high-performance offshore solutions that captivate audiences and drive engagement. We develop immersive games, scalable media platforms, and dynamic content systems designed for seamless cross-platform experiences. Our approach integrates advanced graphics, real-time interactivity, and gamification strategies to boost user retention and monetization. With global delivery capabilities, we help entertainment brands expand rapidly into new markets and stay ahead of digital trends.",
            img: industries05
        },
        {
            title: "Optimize supply chains and transportation networks with Peregrinee’s agile, data-driven offshore logistics software solutions.",
            text: "Peregrinee empowers logistics and supply chain enterprises with advanced offshore software development services designed to boost efficiency, visibility, and control. We build custom logistics platforms, fleet management systems, real-time tracking solutions, warehouse automation tools, and predictive analytics dashboards. Our solutions help businesses reduce operational costs, improve delivery accuracy, and adapt quickly to global logistics challenges—enhancing end-to-end supply chain performance across industries.",
            img: industries06
        },
        {
            title: "Streamline property management and construction workflows with Peregrinee’s scalable, secure offshore software solutions.",
            text: "Peregrinee delivers advanced offshore software development services to the real estate and construction industries, enabling seamless project management, property tracking, and client engagement. Our solutions include construction management platforms, BIM integration tools, real estate CRM systems, and smart contract applications. By leveraging these digital tools, businesses can improve collaboration, reduce project delays, optimize resource allocation, and enhance transparency across the project lifecycle, driving efficiency and growth in a competitive market.",
            img: industries07
        }
    ];
    return (
        <><motion.section id="industries" className="container my-5"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.6 }}
            transition={{ duration: 0.8, ease: "easeOut" }}>
            <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                <div
                    className="px-3 fw-bold responsive-heading"
                >
                    <span className="highlight-orange">Industries</span>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                        Our comprehensive offshore <span className="highlight-orange">software development </span> services cover a wide range of <span className="highlight-orange">industries and sectors. </span>
                    </span>
                </div>
            </div>
            {/* <div className="d-flex justify-content-center mt-4">
        <a
            href="#contact-us"
            className="btn custom-orange-btn py-3 px-4 fw-bold"
        >
            Get in Touch With Us
        </a>
    </div> */}
        </motion.section>
            <section className="container my-5">
                {/* Buttons */}
                <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`btn fw-bold px-4 py-2 ${activeTab === index ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setActiveTab(index)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content Layout */}
                <motion.div
                    className="row g-4 align-items-center shadow rounded bg-white p-4"
                    key={activeTab} // triggers re-animation on tab change
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}>
                    {/* Left: Title & Text */}
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <motion.h4
                            className="fw-bold"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}>
                            {tabContents[activeTab].title}
                        </motion.h4>
                        <motion.p
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.1 }}>
                            {tabContents[activeTab].text}
                        </motion.p>
                    </div>

                    {/* Right: Image */}
                    <motion.div
                        className="col-12 col-md-6"
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, delay: 0.2 }}>
                        <img
                            src={tabContents[activeTab].img}
                            alt="Media & communication industry"
                            className="img-fluid w-100 h-100 object-fit-cover rounded"
                            style={{ objectFit: 'cover' }} />
                    </motion.div>
                </motion.div>
            </section></>
    )
}

export default Industries